import { useFeatureFlagPayload } from 'posthog-js/react'

const useMaintenanceMode = () => {
  return useFeatureFlagPayload('maintenance-active')
}

export default useMaintenanceMode
